import { createApp } from 'vue'

import { createBootstrap, Components as BvnComponents, Directives as BvnDirectives } from 'bootstrap-vue-next'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import '@vuepic/vue-datepicker/dist/main.css'
import BFormDatepicker from '@/components/compat/BFormDatepicker.vue'
import BFormTimepicker from '@/components/compat/BFormTimepicker.vue'
import BMedia from '@/components/compat/BMedia.vue'
import BMediaAside from '@/components/compat/BMediaAside.vue'
import BMediaBody from '@/components/compat/BMediaBody.vue'
import BInputGroupPrepend from '@/components/compat/BInputGroupPrepend.vue'
import BInputGroupAppend from '@/components/compat/BInputGroupAppend.vue'
import BEmbed from '@/components/compat/BEmbed.vue'
import BSkeleton from '@/components/compat/BSkeleton.vue'
import BSkeletonWrapper from '@/components/compat/BSkeletonWrapper.vue'
import BSidebar from '@/components/compat/BSidebar.vue'
import VueTypeaheadBootstrap from '@/components/compat/VueTypeaheadBootstrap.vue'
import i18n from '@/libs/i18n'
import Rollbar from 'rollbar';

import router from './router'
import App from './App.vue'
import store from './store'
import filters from './filters'
import { version } from '../package.json'

// Global Components
import globalComponents from './global-components'

// 3rd party plugins
import axiosIns from '@axios'
import { abilitiesPlugin, ability } from '@/libs/acl'
import Toastification from '@/libs/toastification'

// Axios Mock Adapter
import '@/@fake-db/db'

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

const app = createApp(App)

app.use(globalComponents)

app.component('VueTypeaheadBootstrap', VueTypeaheadBootstrap)

// Bootstrap Vue Next.
// createBootstrap no registra componentes (BVN es tree-shakeable); se registran todos manualmente.
app.use(createBootstrap())

Object.entries(BvnComponents).forEach(([name, component]) => {
  app.component(name, component)
})

Object.entries(BvnDirectives).forEach(([name, directive]) => {
  // 'vBToggle' -> 'b-toggle' para que funcione como v-b-toggle
  const directiveName = name.slice(1).replace(/([A-Z])/g, '-$1').toLowerCase().replace(/^-/, '')
  app.directive(directiveName, directive)
})

// Componentes compat que BVN no trae (wrappers sobre inputs nativos / BVN / markup BS5).
app.component('BFormDatepicker', BFormDatepicker)
app.component('BFormTimepicker', BFormTimepicker)
app.component('BMedia', BMedia)
app.component('BMediaAside', BMediaAside)
app.component('BMediaBody', BMediaBody)
app.component('BInputGroupPrepend', BInputGroupPrepend)
app.component('BInputGroupAppend', BInputGroupAppend)
app.component('BEmbed', BEmbed)
app.component('BSkeleton', BSkeleton)
app.component('BSkeletonWrapper', BSkeletonWrapper)
app.component('BSidebar', BSidebar)
// BVN renombro BCardSubtitle (bootstrap-vue usaba BCardSubTitle, con T mayuscula).
app.component('BCardSubTitle', BvnComponents.BCardSubtitle)


app.use(filters)
app.config.globalProperties.$http = axiosIns

app.use(router)
app.use(store)
app.use(i18n)

// $t en globalProperties para usarlo sincrono en setup() (i18n legacy).
Object.defineProperty(app.config.globalProperties, '$t', {
  configurable: true,
  writable: true,
  value: (...args) => i18n.global.t(...args),
})

app.use(Toastification)

app.use(abilitiesPlugin, ability, { useGlobalProperties: true })

app.config.globalProperties.$rollbar = new Rollbar({
  // Solo reporta en produccion; en dev queda instanciado pero deshabilitado (no envia nada).
  enabled: process.env.NODE_ENV === 'production',
  accessToken: 'c1fe746d804b4d69a3463eb039885853',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    // Track your events to a specific version of code for better visibility into version health
    code_version: version,
  },
});

// If you have already set up a global error handler,
// just add `vm.$rollbar.error(err)` to the top of it.
// If not, this simple example will preserve the app’s existing
// behavior while also reporting uncaught errors to Rollbar.
app.config.errorHandler = (err, vm, info) => {
  if (vm && vm.$rollbar) vm.$rollbar.error(err);
  throw err; // rethrow
};

app.mount('#app')
